export var ConversationUpdateType;

(function (ConversationUpdateType) {
  ConversationUpdateType["TYPING_INDICATOR"] = "TYPING_INDICATOR";
  ConversationUpdateType["MESSAGE_STREAM_CHUNK"] = "MESSAGE_STREAM_CHUNK";
  ConversationUpdateType["MESSAGE_STREAM_DONE"] = "MESSAGE_STREAM_DONE";
  ConversationUpdateType["MESSAGE_RECEIVED"] = "MESSAGE_RECEIVED";
  ConversationUpdateType["INSUFFICIENT_BALANCE"] = "INSUFFICIENT_BALANCE";
  ConversationUpdateType["ERROR"] = "ERROR";
})(ConversationUpdateType || (ConversationUpdateType = {}));